<template>
  <section class="dashboard-hear">
    <Breadcrumbs
      :breadcrumbs="[
        {title: $t('menu.statistics-2'), disabled: true},
        {title: $t('menu.statistics2/dashboard-hear'), disabled: true}
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Filters
          :isActive="showFilters"
          :active-filters="activeFilters"
          @toggle-filters="toggleFilters"/>
      </div>
    </Breadcrumbs>


    <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
      <div class="row">
        <div class="col-12 col-md-4">
          <range-date-picker
            id="statistics-date-range"
            :label="$t('statistics2.hear.sublabels.period')"
            v-model="filters.dateRange"
            placeholder="---"
            :config="{ maxInterval: { value: 12, unit: 'months' } }"
            :clearable="false"
          >
          </range-date-picker>
        </div>

        <div class="col-12 col-md-4">
          <label class="form-label">
            {{ $t('statistics.csm.entities') }}
          </label>
          <multiselect
            id="entities-filter"
            v-model="filters.entities"
            :options="entityOptions"
            track-by="uid"
            :customLabel="formatedEntityLabel"
            :placeholder="entityOptions.length ? $t('clinical.waiting_room_statistics.several_entities') : $t('clinical.waiting_room_statistics.no_entities')"
            :allow-empty="true"
            :multiple="true"
            :internal-search="false"
            :disabled="!entityOptions.length || isRequestingData"
            @search-change="asyncFind"
          >

            <template slot="clear">
            <span class="multiselect__clear" v-if="filters.entities.length"
                  @mousedown.prevent.stop="filters.entities = []"></span>
            </template>
          </multiselect>
        </div>

        <div class="col-12 col-md-4">
          <label class="form-label">
            {{ $t('entities.business_plan') }}
          </label>
          <multiselect
            id="business-plans-filter"
            v-model="filters.businessPlans"
            :options="businessPlansOptions"
            track-by="id"
            label="name"
            :placeholder="'---'"
            :allow-empty="true"
            :multiple="true"
            :disabled="!businessPlansOptions.length || !filters.entities.length || businessPlansOptions.length === 1"
          >

            <template slot="clear">
            <span class="multiselect__clear" v-if="filters.businessPlans.length"
                  @mousedown.prevent.stop="filters.businessPlans = []"></span>
            </template>
          </multiselect>
        </div>
      </div>

    </div>

    <div class="dashboard-hear-placeholder mt-2" v-if="!isLoading">

      <!--<h4 class="text--bold">General Kpis</h4>-->
      <br>
      <div class="general-kpis row">
        <div class=" row col-12 col-md-12">
          <va-card class="info-widget mr-4">
            <va-popover
              placement="top"
              :message="$t('statistics2.hear.labels.pharmacies_universe')">
              <i class="i-dashboard-hear-pharmacies-universe svg-kpi"></i>&nbsp;
              <span class="kpi-content">  {{ receivedData.pharmacies_universe }} </span>
            </va-popover>
          </va-card>
          <va-card class="info-widget mr-4">
            <va-popover
              placement="top"
              :message="$t('statistics2.hear.labels.pharmacies_with_contract')">
              <i class="i-dashboard-hear-pharmacies-with-contract svg-kpi"></i>&nbsp;
              <span class="kpi-content">  {{ receivedData.pharmacies_with_contract }} </span>
            </va-popover>
          </va-card>
          <va-card class="info-widget mr-4">
            <va-popover
              placement="top"
              :message="$t('statistics2.hear.labels.fte')">
              <i class="i-dashboard-hear-fte svg-kpi"></i>&nbsp;
              <span class="kpi-content">  {{ receivedData.fte ? receivedData.fte : 'N/A'}} </span>
            </va-popover>
          </va-card>

          <va-card class="info-widget mr-4">
            <va-popover
              placement="top"
              :message="$t('statistics2.hear.labels.screenings_current_month')">
              <i class="i-dashboard_hear_screenings_month svg-kpi"></i>&nbsp;
              <span class="kpi-content">  {{ receivedData.screenings_current_month }} </span>
            </va-popover>
          </va-card>
          <va-card class="info-widget mr-4">
            <va-popover
              placement="top"
              :message="$t('statistics2.hear.labels.screenings_next_month')">
              <i class="i-dashboard_hear_screenings_next_month svg-kpi"></i>&nbsp;
              <span class="kpi-content">  {{ receivedData.screenings_next_month }} </span>
            </va-popover>
          </va-card>
          <va-card class="info-widget mr-4">
            <va-popover
              placement="top"
              :message="$t('statistics2.hear.labels.screenings_until_now')">
              <div style="width: 120%; display: table">
                <div style="display: table-row">
                  <div style="width: 20%; display: table-cell; vertical-align: bottom">
                    <i class="i-dashboard-hear-screenings-made svg-kpi"></i>
                  </div>

                  <div style="display: table-cell;">
                    <div style="width: 100%; margin-left: 10px; display: table; line-height: initial">
                      <div style="display: table-row;">
                        <div style="width: 10%; display: table-cell;">
                          <span class="kpi-multiple-content"> {{ receivedData.screeningsThisDayUntilNow }}</span>&nbsp;
                        </div>
                        <div style="display: table-cell; text-align: left">
                          <span class="kpi-multiple-content-indicator">{{ $t('statistics2.hear.sublabels.day') }}</span>
                        </div>
                      </div>

                      <div style="display: table-row;">
                        <div style="width: 10%; display: table-cell;">
                          <span class="kpi-multiple-content"> {{ receivedData.screeningsPeriod }}</span>&nbsp;
                        </div>
                        <div style="display: table-cell; text-align: left">
                          <span class="kpi-multiple-content-indicator">{{
                              $t('statistics2.hear.sublabels.period')
                            }}</span>
                        </div>
                      </div>

                      <div style="display: table-row;">
                        <div style="width: 10%; display: table-cell;">
                          <span class="kpi-multiple-content"> {{
                              receivedData.screeningsHomologousPeriod
                            }}</span>&nbsp;

                        </div>
                        <div style="display: table-cell; text-align: left">
                          <span class="kpi-multiple-content-indicator">{{
                              $t('statistics2.hear.sublabels.homologous_period')
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>


              </div>
            </va-popover>
          </va-card>

          <va-card class="info-widget mr-4">
            <va-popover
              placement="top"
              :message="$t('statistics2.hear.labels.diff_pc_screenings')">
              <div style="width: 120%; display: table">
                <div style="display: table-row">
                  <div style="width: 20%; display: table-cell; vertical-align: bottom">
                    <i class="i-dashboard-hear-fte svg-kpi"></i>
                  </div>

                  <div style="display: table-cell;">
                    <div style="width: 100%; margin-left: 10px; display: table; line-height: initial">
                      <div style="display: table-row;">
                        <div style="width: 10%; display: table-cell;">
                          <span class="kpi-multiple-content"> {{ receivedData.diffPcScreeningsDay }}</span>&nbsp;
                        </div>
                        <div style="display: table-cell; text-align: left">
                          <span class="kpi-multiple-content-indicator">{{ $t('statistics2.hear.sublabels.day') }}</span>
                        </div>
                      </div>

                      <div style="display: table-row;">
                        <div style="width: 10%; display: table-cell;">
                          <span class="kpi-multiple-content"> {{ receivedData.diffPcScreeningsPeriod }}</span>&nbsp;
                        </div>
                        <div style="display: table-cell; text-align: left">
                          <span class="kpi-multiple-content-indicator">{{
                              $t('statistics2.hear.sublabels.period')
                            }}</span>
                        </div>
                      </div>

                      <div style="display: table-row;">
                        <div style="width: 10%; display: table-cell;">
                          <span class="kpi-multiple-content"> {{
                              receivedData.diffPcScreeningsHomologousPeriod
                            }}</span>&nbsp;
                        </div>
                        <div style="display: table-cell; text-align: left">
                          <span class="kpi-multiple-content-indicator">{{
                              $t('statistics2.hear.sublabels.homologous_period')
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>


              </div>
            </va-popover>
          </va-card>
        </div>
      </div>


    </div>

    <div class="table-placeholder" v-show="false">
      <div class="col-12 mt-4">
        <v-client-table
          id="statsTable"
          ref="statsTable"
          name="statsTable"
          :data="statsTableData"
          :columns="statsTableColumns"
          :options="statsTableOptions"
        >
        </v-client-table>
      </div>
    </div>
    <div class="row justify--center mt-4" style="margin-left: -10%">
      <ul>
        <li v-for="(item, key) in statsTableData" class="indicator-li">
          {{ item.indicator }}
        </li>
      </ul>
      <ul class="funnel" :key="funnelComponentKey">
        <li v-for="(item, key) in statsTableData">
          <div class="kpi-div">
            <label class="kpi-day">
              {{ item.day }}
            </label>
            <label class="label-kpi-description">
              {{ $t('statistics2.hear.sublabels.day')}}
            </label>
          </div>
          <div class="kpi-div">
            <label class="kpi-period">
              {{item.period}}
            </label>
            <label class="label-kpi-description-2">
              {{ $t('statistics2.hear.sublabels.period') }}
            </label>

            <label class="kpi-homologous-period">
              {{item.homologousPeriod}}
            </label>
            <label class="label-kpi-description-2">
              {{ $t('statistics2.hear.sublabels.homologous_period') }}
            </label>
          </div>
        </li>
      </ul>
    </div>


  </section>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import {Statistics2Service} from "@/api/StatisticsService";
import Multiselect from 'vue-multiselect'
import Vue from "vue";
import {ClientTable} from 'vue-tables-2'
import RangeDatePicker from "@/components/common/RangeDatePicker";
import MultiselectLabelFormatter from "@/mixins/MultiselectLabelFormatter";
import ClustersAndEntitiesMixin from "@/mixins/ClustersAndEntitiesMixin";
import {mapGetters} from "vuex";
import {ProductsService} from "@/api/AuthService";
import LocalStorageHelper from "@/local-storage/LocalStorageHelper";
import { STATISTICS2_DASHBOARD_HEAR} from "@/local-storage/LocalStorageKeys";
import {get as _get} from "lodash";
import Filters from '@/components/common/Filters'

Vue.use(ClientTable, {}, false, 'bootstrap4')

export default {
  mixins: [MultiselectLabelFormatter, ClustersAndEntitiesMixin],
  components: {Breadcrumbs, Multiselect, RangeDatePicker, Filters},
  data() {
    return {
      funnelComponentKey: 0,
      showFilters: false,
      activeFilters: 0,
      hasLoadedLocalStorage: false,
      entitiesAllowed: [],
      clustersAllowed: [],
      entityOptions: [],
      businessPlansOptions: [],
      selectedEntityIds: [],
      selectedEntityUids: [],
      isRequestingData: false,
      receivedData: [],
      statsTableColumns: ['indicator', 'day', 'period', 'homologousPeriod'],
      statsTableOptions: {
        headings: {
          'indicator': "KPI",
          'day': this.$t('statistics2.hear.sublabels.day'),
          'period': this.$t('statistics2.hear.sublabels.period'),
          'homologousPeriod': this.$t('statistics2.hear.sublabels.homologous_period')
        },
        columnsClasses: {
          day: 'column-center',
          period: 'column-center',
          homologousPeriod: 'column-center'
        },
        skin: 'table table-striped table-hover is-fullwidth',
        columnsDropdown: false,
        filterable: false,
        sortable: [],
      },
      statsTableData: [],

      isLoading: true,
      indicators: [
        {id: 1, label: this.$t('statistics2.hear.sublabels.day')},
        {id: 2, label: this.$t('statistics2.hear.sublabels.period')},
        {id: 3, label: this.$t('statistics2.hear.sublabels.homologous_period')}
      ],
      filters: {
        entities: [],
        businessPlans: [],
        dateRange: {
          start: this.moment().startOf('month').format('YYYY-MM-DD'),
          end: this.moment().endOf('month').format('YYYY-MM-DD'),
        }
      },

      extractedDayData: [],
      extractedPeriodData: [],
      extractedHomologousPeriodData: [],
    };
  },
  async created() {
    this.isLoading = true
    await this.loadLocalStorage()
    this.$store.dispatch('LOAD_BUSINESS_PLANS')
    this.entitiesAllowed = this.authorizedEntities
    this.entitiesAllowed = this.entitiesAllowed.filter(ent => ent.business_plan_id === 5 || ent.business_plan_id === 7)
    let entitiesAllowedIds = this.entitiesAllowed.map(ent => ent.id)
    this.clustersAllowed = this.clusters
    this.clustersAllowed = this.clustersAllowed.filter(cluster => cluster.entitiesIds.some(id => entitiesAllowedIds.includes(id)))
    this.generateEntityOptions()

    await this.getStatistics()
      .then(() => {
        this.isRequestingData = false
        this.isLoading = false
        ++this.funnelComponentKey
      })



  },
  methods: {
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    resetGraph() {
      this.filters.graphIndicators = this.indicators[1]
      this.graphKey = this.graphKey + 1
    },

    asyncFind(search_query) {
      this.generateEntityOptions(search_query)
    },
    generateEntityOptions(search_query) {
      if (search_query) {
        this.entityOptions = this.createClustersAndEntitiesListSearch(this.clustersAllowed, this.entitiesAllowed, search_query)
      } else {
        this.entityOptions = this.createClustersAndEntitiesList(this.clustersAllowed, this.entitiesAllowed)
      }

    },
    getStatistics: function () {
      return new Promise(async (resolve, reject) => {
        try {
          let params =  this.getActiveFilters()
          let data = await Statistics2Service.getHearingDashboardData(params)
          this.receivedData = data.data
          const objKeys = Object.keys(data.data.dayData)
          this.labels = objKeys.map(label => this.$t(`statistics2.hear.labels.${label}`))
          this.extractedDayData = Object.values(data.data.dayData)
          this.extractedPeriodData = Object.values(data.data.periodData)
          this.extractedHomologousPeriodData = Object.values(data.data.homologousPeriodData)

          this.statsTableData = []
          objKeys.forEach((elem, index) => {
            this.statsTableData.push({
              id: index,
              indicator: this.$t(`statistics2.hear.labels.${elem}`),
              day: this.extractedDayData[index],
              period: this.extractedPeriodData[index],
              homologousPeriod: this.extractedHomologousPeriodData[index]
            })
          })

          await this.saveLocalStorage()
          resolve()

        } catch (e) {
          console.log(e)
          this.showToast(this.$t('clinical.waiting_room_statistics.something_went_wrong'), this.$store.state.errorToastOptions)
          reject(e)
        }

      })
    },
    getActiveFilters: function () {
      let entities = null
      if (this.filters.entities.length) {
        if(this.filters.entities[0].entities !== undefined) {
          entities = this.filters.entities[0].entities.map(entity => entity.id).join(',')
        } else {
          entities = this.filters.entities.map(entity => entity.id).join(',')
        }
      }

      let filters = {
        start: _get(this.filters, 'dateRange.start', null) || undefined,
        end: _get(this.filters, 'dateRange.end', null) || undefined,
        ...this.filters.businessPlans.length && { businessPlans: this.filters.businessPlans.map(bp => bp.id).join(',') },
        selectedEntityUids: Array.from(this.selectedEntityUids) || null
      }
      if(entities) {
        filters.entities = entities
      }
      return filters
    },
    loadLocalStorage: async function () {
      const state = LocalStorageHelper.get(STATISTICS2_DASHBOARD_HEAR)
      if (state) {
        // s date filters from local storage
        if (state.start && state.start !== '' && state.end && state.end !== '') {
          this.filters.dateRange.start = state.start
          this.filters.dateRange.end = state.end
        }

        if (Array.isArray(state.selectedEntityUids) && state.selectedEntityUids && state.selectedEntityUids.length > 0) {
          this.filters.entities = this.reloadSelectedClustersAndEntities(this.entitiesAllowed, state.selectedEntityUids)
        }

        if (state.businessPlans && state.businessPlans !== '') {
          let businessPlansIds = state.businessPlans.split(',')
          this.filters.businessPlans = this.businessPlansOptions.filter(bp => businessPlansIds.includes(bp.id))
        }
      }
    },
    saveLocalStorage: function () {
      LocalStorageHelper.set(STATISTICS2_DASHBOARD_HEAR, {
        ...this.getActiveFilters(),
      })
      this.hasLoadedLocalStorage = true
    },
  },
  computed: {
    ...mapGetters({
      clusters: 'clusters',
      businessPlans: 'businessPlans'
    }),
    authorizedEntities: function () {
      let statsV2Service = this.$store.state.services.find(service => service.url === this.$store.state.statistics2_server) || null
      if (statsV2Service) {
        if (statsV2Service.user_permissions.some(p => p.entity_id === null)) {
          return statsV2Service.entities
        } else {
          return statsV2Service.entities.filter(entity => statsV2Service.user_permissions.filter(p => p.entity_id === entity.id))
        }
      }
      return null
    },
  },
  watch: {
    'filters.dateRange': {
      handler: function () {
        if (this.hasLoadedLocalStorage) {
          this.isRequestingData = true
          this.getStatistics()
            .then(() => {
              this.isRequestingData = false
            })
        }
      },
      deep: true
    },
    'filters.entities': function (val) {
      if (this.hasLoadedLocalStorage) {
        if (val.length > 0) {
          this.isRequestingData = true
          const selectedOptions = this.getSelectedOptionsIdsAndUids(val)
          this.selectedEntityIds = Array.from(selectedOptions.ids).join(',')
          this.selectedEntityUids = selectedOptions.uids
          const selectedEntities = this.entityOptions.filter(ent => this.selectedEntityIds.includes(ent.id) && ent.business_plan_id)
          const businessPlansToConsider = selectedEntities.map(ent => ent.business_plan_id)
          this.businessPlansOptions = this.businessPlans.filter(bp => businessPlansToConsider.includes(bp.id))

          if (this.filters.businessPlans.length > 0) {
            this.filters.businessPlans = this.filters.businessPlans.filter(item => businessPlansToConsider.includes(item.id))
          }
        } else {
          this.businessPlansOptions = []
          this.filters.businessPlans = []
        }

        if(this.businessPlansOptions.length === 1) {
          this.filters.businessPlans.push(this.businessPlansOptions[0])
        }

        this.getStatistics()
          .then(() => {
            this.isRequestingData = false
          })
      }
    },
  }

}
</script>

<style lang="scss">


.funnel {
  width: 700px;
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: center;
  color: #fff;

  .kpi-div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .kpi-day{
    font-size: 22px;
    font-weight: bold
  }

  .kpi-period {
    font-size: 18px; font-weight: bold
  }

  .kpi-homologous-period {
    padding-left: 20px;
    font-size: 18px; font-weight: bold
  }

  .label-kpi-description {
    padding-left: 4px;
    font-size: 16px;
    font-weight: normal
  }

  .label-kpi-description-2 {
    padding-left: 4px;
    font-size: 12px;
    font-weight: normal
  }

  li span {
    color: red;
    position: absolute;
    left: 60%;
    white-space: nowrap;
    margin-left: 100px;
  }

  li {
    padding: 10px 5px;
    margin: 0;
    background-color: #DC584F;
    margin-bottom: 5px;
    position: relative;
    overflow: hidden;
    height: 90px;
  }

  div:last-child {
    font-size: 20px
  }

  li:before, li:after {
    content: '';
    position: absolute;
    top: 0;
    height: 0;
    border-bottom: 90px solid #f5f5f5;
  }

  li:before {
    left: 0;
    border-right: 27px solid transparent;
    border-left: 0;
  }

  li:after {
    right: 0;
    border-left: 27px solid transparent;
    border-right: 0;
  }

  li:nth-child(1):before, li:nth-child(1):after { width: 0px; }
  li:nth-child(2):before, li:nth-child(2):after { width: 50px; }
  li:nth-child(3):before, li:nth-child(3):after { width: 75px; }
  li:nth-child(4):before, li:nth-child(4):after { width: 100px; }
  li:nth-child(5):before, li:nth-child(5):after { width: 125px; }
  li:nth-child(6):before, li:nth-child(6):after { width: 150px; }
  li:nth-child(7):before, li:nth-child(7):after { width: 175px; }
  li:nth-child(8):before, li:nth-child(8):after { width: 200px; }
  li:nth-child(9):before, li:nth-child(9):after { width: 225px; }

  li:nth-child(6) {background-color: #0070C0 !important}
  li:nth-child(7) {background-color: #0070C0 !important}
  li:nth-child(8) {background-color: #0070C0 !important}
  li:nth-child(9) {background-color: #0070C0 !important}
}


.indicator-div {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: right;
  padding: 10px 5px;
  margin: 0;
  background-color: #409ca9;
  margin-bottom: 5px;
  position: relative;
  overflow: hidden;
  height: 90px;
}
.indicator-li {
  font-weight: bold;
  font-size: 1.2rem;
  height: 90px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: right
}

.general-kpis {
  margin-left: 20px !important;
}

.va-card__body {
  text-align: center;
  vertical-align: middle;
  line-height: 50px;
}

.info-widget {
  width: 200px;
  height: 100px;

}

.svg-kpi {
  filter: invert(46%) sepia(13%) saturate(9%) hue-rotate(23deg) brightness(90%) contrast(99%);
}

.kpi-content {
  font-size: 1.5rem;
  font-weight: bold;
  vertical-align: text-bottom;
}

.kpi-multiple-content {
  text-align: left;
  font-size: 1.1rem;
  font-weight: bold;

}

.kpi-multiple-content-indicator {
  font-size: 12px;
}

.daily-kpi-card {
  width: 150px;
  height: 80px;
}

.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__value {
  color: #181818 !important;
}

.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__title {
  color: $vue-green !important;
}

.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__percentage {
  color: #7e7e7e !important;
}

.svg-funnel-js .svg-funnel-js__subLabels .svg-funnel-js__subLabel {
  color: #7e7e7e !important;
}

.svg-funnel-js.svg-funnel-js--vertical .svg-funnel-js__label {
  padding-top: 10px !important;
}

.float-container {
  padding: 20px;
}

.float-child-first {
  width: 23%;
  float: left;
}

.float-child {
  width: 2%;
  float: left;
}

.float-child-last {
  width: 98%;
  float: right;
  padding: 5px;
}


#statsTable {

  .number-widget {
    background: #f0f0f0;
    border-radius: 0.375rem;
    padding: 2rem 1rem;

    h2 {
      color: $evollu-gray-light;
    }
  }

  .table-bordered th {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 2px solid #cecece;
  }

  .table-bordered td {
    border: 0 !important;
  }

  .VuePagination {
    display: none !important;
  }

  .column-center {
    text-align: center;
  }
}
</style>
